
export const ErrorGraphic = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="svg637"
    viewBox="0 0 500 500"
  >
    <defs id="defs485-123230841248">
      <linearGradient
        id="linear-gradient"
        x1={63.91}
        x2={240.64}
        y1={257.66}
        y2={257.66}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop184-123230841248" offset={0.19} stopColor="#ae4b80" />
        <stop
          id="stop186-123230841248"
          offset={0.38}
          stopColor="#ad4a7f"
          stopOpacity={0.99}
        />
        <stop
          id="stop188-123230841248"
          offset={0.45}
          stopColor="#ad4a7f"
          stopOpacity={0.95}
        />
        <stop
          id="stop190-123230841248"
          offset={0.49}
          stopColor="#ac4a7f"
          stopOpacity={0.89}
        />
        <stop
          id="stop192-123230841248"
          offset={0.53}
          stopColor="#ab497e"
          stopOpacity={0.8}
        />
        <stop
          id="stop194-123230841248"
          offset={0.56}
          stopColor="#aa497e"
          stopOpacity={0.7}
        />
        <stop
          id="stop196-123230841248"
          offset={0.58}
          stopColor="#aa497e"
          stopOpacity={0.64}
        />
        <stop
          id="stop198-123230841248"
          offset={0.63}
          stopColor="#ab497e"
          stopOpacity={0.47}
        />
        <stop
          id="stop200-123230841248"
          offset={0.69}
          stopColor="#ac4a7f"
          stopOpacity={0.19}
        />
        <stop id="stop202-123230841248" offset={0.73} stopColor="#ae4b80" stopOpacity={0} />
        <stop id="stop204-123230841248" offset={1} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-2"
        x1={248.43}
        x2={410.4}
        y1={237.47}
        y2={237.47}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop207-123230841248" offset={0.01} stopColor="#ae4b80" stopOpacity={0} />
        <stop
          id="stop209-123230841248"
          offset={0.15}
          stopColor="#ae4b80"
          stopOpacity={0.01}
        />
        <stop
          id="stop211-123230841248"
          offset={0.19}
          stopColor="#ae4b80"
          stopOpacity={0.05}
        />
        <stop
          id="stop213-123230841248"
          offset={0.23}
          stopColor="#ae4b80"
          stopOpacity={0.12}
        />
        <stop
          id="stop215-123230841248"
          offset={0.25}
          stopColor="#ae4b80"
          stopOpacity={0.21}
        />
        <stop
          id="stop217-123230841248"
          offset={0.28}
          stopColor="#ae4b80"
          stopOpacity={0.34}
        />
        <stop
          id="stop219-123230841248"
          offset={0.3}
          stopColor="#ae4b80"
          stopOpacity={0.49}
        />
        <stop id="stop221-123230841248" offset={0.3} stopColor="#ae4b80" stopOpacity={0.5} />
        <stop
          id="stop223-123230841248"
          offset={0.37}
          stopColor="#ae4b80"
          stopOpacity={0.52}
        />
        <stop
          id="stop225-123230841248"
          offset={0.44}
          stopColor="#ae4b80"
          stopOpacity={0.59}
        />
        <stop
          id="stop227-123230841248"
          offset={0.51}
          stopColor="#ae4b80"
          stopOpacity={0.7}
        />
        <stop
          id="stop229-123230841248"
          offset={0.58}
          stopColor="#ae4b80"
          stopOpacity={0.86}
        />
        <stop id="stop231-123230841248" offset={0.63} stopColor="#ae4b80" />
        <stop
          id="stop233-123230841248"
          offset={0.78}
          stopColor="#ad4a7f"
          stopOpacity={0.99}
        />
        <stop
          id="stop235-123230841248"
          offset={0.83}
          stopColor="#ab497e"
          stopOpacity={0.95}
        />
        <stop
          id="stop237-123230841248"
          offset={0.87}
          stopColor="#a7487c"
          stopOpacity={0.88}
        />
        <stop
          id="stop239-123230841248"
          offset={0.9}
          stopColor="#a2467a"
          stopOpacity={0.79}
        />
        <stop
          id="stop241-123230841248"
          offset={0.93}
          stopColor="#9b4376"
          stopOpacity={0.66}
        />
        <stop
          id="stop243-123230841248"
          offset={0.95}
          stopColor="#933f72"
          stopOpacity={0.5}
        />
        <stop
          id="stop245-123230841248"
          offset={0.97}
          stopColor="#893b6d"
          stopOpacity={0.32}
        />
        <stop
          id="stop247-123230841248"
          offset={0.99}
          stopColor="#7d3667"
          stopOpacity={0.11}
        />
        <stop id="stop249-123230841248" offset={1} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-3"
        x1={424.42}
        x2={376.64}
        y1={103.29}
        y2={388.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop252-123230841248" offset={0} stopColor="#ae4b80" />
        <stop
          id="stop254-123230841248"
          offset={0.09}
          stopColor="#a6487c"
          stopOpacity={0.76}
        />
        <stop
          id="stop256-123230841248"
          offset={0.22}
          stopColor="#9d4478"
          stopOpacity={0.44}
        />
        <stop
          id="stop258-123230841248"
          offset={0.34}
          stopColor="#954174"
          stopOpacity={0.2}
        />
        <stop
          id="stop260-123230841248"
          offset={0.43}
          stopColor="#913f72"
          stopOpacity={0.05}
        />
        <stop id="stop262-123230841248" offset={0.49} stopColor="#903f72" stopOpacity={0} />
        <stop
          id="stop264-123230841248"
          offset={0.56}
          stopColor="#8e3e71"
          stopOpacity={0.05}
        />
        <stop
          id="stop266-123230841248"
          offset={0.67}
          stopColor="#8b3c6f"
          stopOpacity={0.19}
        />
        <stop
          id="stop268-123230841248"
          offset={0.78}
          stopColor="#853a6c"
          stopOpacity={0.42}
        />
        <stop
          id="stop270-123230841248"
          offset={0.91}
          stopColor="#7e3668"
          stopOpacity={0.74}
        />
        <stop id="stop272-123230841248" offset={1} stopColor="#783465" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-4"
        x1={56.7}
        x2={209.74}
        y1={132.44}
        y2={92.97}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop275-123230841248" offset={0.16} stopColor="#ae4b80" />
        <stop
          id="stop277-123230841248"
          offset={0.55}
          stopColor="#933f72"
          stopOpacity={0.5}
        />
        <stop
          id="stop279-123230841248"
          offset={0.85}
          stopColor="#7f3768"
          stopOpacity={0.14}
        />
        <stop id="stop281-123230841248" offset={1} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-5"
        x1={73.49}
        x2={84.16}
        y1={123.99}
        y2={284.43}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop284-123230841248" offset={0} stopColor="#ae4b80" />
        <stop
          id="stop286-123230841248"
          offset={0.46}
          stopColor="#933f72"
          stopOpacity={0.5}
        />
        <stop
          id="stop288-123230841248"
          offset={0.83}
          stopColor="#7f3768"
          stopOpacity={0.14}
        />
        <stop id="stop290-123230841248" offset={1} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-6"
        x1={97.93}
        x2={87.25}
        y1={459.8}
        y2={274.48}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop293-123230841248" offset={0} stopColor="#ae4b80" />
        <stop
          id="stop295-123230841248"
          offset={0.38}
          stopColor="#933f72"
          stopOpacity={0.5}
        />
        <stop
          id="stop297-123230841248"
          offset={0.69}
          stopColor="#7f3768"
          stopOpacity={0.14}
        />
        <stop id="stop299-123230841248" offset={0.83} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-7"
        x1={443.85}
        x2={282.71}
        y1={90.51}
        y2={106.78}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop302-123230841248" offset={0.17} stopColor="#ae4b80" />
        <stop
          id="stop304-123230841248"
          offset={0.26}
          stopColor="#a6477c"
          stopOpacity={0.86}
        />
        <stop
          id="stop306-123230841248"
          offset={0.52}
          stopColor="#923f72"
          stopOpacity={0.49}
        />
        <stop
          id="stop308-123230841248"
          offset={0.74}
          stopColor="#84396b"
          stopOpacity={0.23}
        />
        <stop
          id="stop310-123230841248"
          offset={0.9}
          stopColor="#7b3566"
          stopOpacity={0.06}
        />
        <stop id="stop312-123230841248" offset={1} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-8"
        x1={94.07}
        x2={264.02}
        y1={438.77}
        y2={395.42}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop315-123230841248" offset={0.16} stopColor="#ae4b80" />
        <stop
          id="stop317-123230841248"
          offset={0.33}
          stopColor="#9b4376"
          stopOpacity={0.66}
        />
        <stop
          id="stop319-123230841248"
          offset={0.5}
          stopColor="#8c3c6f"
          stopOpacity={0.37}
        />
        <stop
          id="stop321-123230841248"
          offset={0.64}
          stopColor="#813769"
          stopOpacity={0.17}
        />
        <stop
          id="stop323-123230841248"
          offset={0.76}
          stopColor="#7a3566"
          stopOpacity={0.05}
        />
        <stop id="stop325-123230841248" offset={0.83} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-9"
        x1={384.17}
        x2={264.66}
        y1={391.02}
        y2={400.07}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop328-123230841248" offset={0} stopColor="#ae4b80" />
        <stop
          id="stop330-123230841248"
          offset={0.31}
          stopColor="#933f72"
          stopOpacity={0.5}
        />
        <stop
          id="stop332-123230841248"
          offset={0.56}
          stopColor="#7f3768"
          stopOpacity={0.14}
        />
        <stop id="stop334-123230841248" offset={0.67} stopColor="#783465" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-5"
        id="linear-gradient-123230841248-10"
        x1={214.16}
        x2={209.73}
        y1={99.67}
        y2={100.89}
      />
      <linearGradient
        id="linear-gradient-123230841248-11"
        x1={170.03}
        x2={173.41}
        y1={66.53}
        y2={90.05}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop338-123230841248" offset={0} stopColor="#783465" stopOpacity={0} />
        <stop
          id="stop340-123230841248"
          offset={0.21}
          stopColor="#783465"
          stopOpacity={0.02}
        />
        <stop
          id="stop342-123230841248"
          offset={0.36}
          stopColor="#7b3666"
          stopOpacity={0.07}
        />
        <stop
          id="stop344-123230841248"
          offset={0.49}
          stopColor="#803a69"
          stopOpacity={0.16}
        />
        <stop
          id="stop346-123230841248"
          offset={0.61}
          stopColor="#873e6c"
          stopOpacity={0.29}
        />
        <stop
          id="stop348-123230841248"
          offset={0.73}
          stopColor="#904571"
          stopOpacity={0.45}
        />
        <stop
          id="stop350-123230841248"
          offset={0.83}
          stopColor="#9b4c76"
          stopOpacity={0.65}
        />
        <stop
          id="stop352-123230841248"
          offset={0.93}
          stopColor="#a7557c"
          stopOpacity={0.88}
        />
        <stop id="stop354-123230841248" offset={0.98} stopColor="#ae5a80" />
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-11"
        id="linear-gradient-123230841248-12"
        x1={125.76}
        x2={127.98}
        y1={66.2}
        y2={81.62}
      />
      <linearGradient
        id="linear-gradient-123230841248-13"
        x1={409.64}
        x2={440.67}
        y1={187.1}
        y2={403.27}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop358-123230841248" offset={0} stopColor="#783465" stopOpacity={0} />
        <stop id="stop360-123230841248" offset={0.98} stopColor="#ae5a80" />
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-13"
        id="linear-gradient-123230841248-14"
        x1={423.06}
        x2={443.19}
        y1={265.21}
        y2={405.4}
      />
      <linearGradient
        id="linear-gradient-123230841248-15"
        x1={130.3}
        x2={149.52}
        y1={321.62}
        y2={319.6}
        gradientTransform="rotate(5.94 137.82 320.814)"
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop364-123230841248" offset={0} stopColor="#ea7aa8" />
        <stop
          id="stop366-123230841248"
          offset={0.07}
          stopColor="#ea7aa8"
          stopOpacity={0.96}
        />
        <stop
          id="stop368-123230841248"
          offset={0.2}
          stopColor="#ea7aa8"
          stopOpacity={0.84}
        />
        <stop
          id="stop370-123230841248"
          offset={0.36}
          stopColor="#ea7aa8"
          stopOpacity={0.66}
        />
        <stop
          id="stop372-123230841248"
          offset={0.41}
          stopColor="#ea7aa8"
          stopOpacity={0.6}
        />
        <stop id="stop374-123230841248" offset={0.8} stopColor="#ea7aa8" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-123230841248-16"
        x1={129.49}
        x2={130.63}
        y1={228.73}
        y2={257.39}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop377-123230841248" offset={0} stopColor="#449dae" />
        <stop id="stop379-123230841248" offset={0.26} stopColor="#26748b" />
        <stop id="stop381-123230841248" offset={0.5} stopColor="#115772" />
        <stop id="stop383-123230841248" offset={0.71} stopColor="#044563" />
        <stop id="stop385-123230841248" offset={0.86} stopColor="#003f5e" />
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-17"
        x1={130.36}
        x2={135.22}
        y1={251.03}
        y2={281.55}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-18"
        x1={146.31}
        x2={151.17}
        y1={403.03}
        y2={433.56}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-19"
        x1={142.75}
        x2={147.6}
        y1={369.48}
        y2={400}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-20"
        x1={139.13}
        x2={144.17}
        y1={338.27}
        y2={365.07}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-21"
        x1={137.99}
        x2={142.84}
        y1={323.55}
        y2={354.07}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-15"
        id="linear-gradient-123230841248-22"
        x1={278.5}
        x2={297.72}
        y1={291.34}
        y2={289.31}
        gradientTransform="scale(-1 1) rotate(-84.06 -6.911 615.177)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-23"
        x1={278.56}
        x2={283.42}
        y1={220.75}
        y2={251.27}
        gradientTransform="scale(-1 1) rotate(2.69 .012 -12178.23)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-24"
        x1={294.52}
        x2={299.37}
        y1={372.75}
        y2={403.27}
        gradientTransform="scale(-1 1) rotate(2.69 .012 -12178.23)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-25"
        x1={290.95}
        x2={295.8}
        y1={339.2}
        y2={369.72}
        gradientTransform="scale(-1 1) rotate(2.69 .012 -12178.23)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-26"
        x1={286.19}
        x2={291.05}
        y1={293.27}
        y2={323.79}
        gradientTransform="scale(-1 1) rotate(2.69 .012 -12178.23)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-15"
        id="linear-gradient-123230841248-27"
        x1={181.94}
        x2={201.09}
        y1={333.7}
        y2={331.68}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-15"
        id="linear-gradient-123230841248-28"
        x1={265.6}
        x2={284.98}
        y1={317.22}
        y2={315.18}
        gradientTransform="scale(-1 1) rotate(2.48 6.995 -13941.01)"
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-29"
        x1={339.87}
        x2={341}
        y1={356.81}
        y2={380.26}
      />
      <linearGradient
        xlinkHref="#linear-gradient-123230841248-16"
        id="linear-gradient-123230841248-30"
        x1={343.59}
        x2={344.72}
        y1={295.14}
        y2={315.8}
      />
      <linearGradient
        id="linear-gradient-123230841248-31"
        x1={346.98}
        x2={345.31}
        y1={259.99}
        y2={282.32}
        gradientUnits="userSpaceOnUse"
      >
        <stop id="stop474-123230841248" offset={0} stopColor="#449dae" />
        <stop id="stop476-123230841248" offset={0.19} stopColor="#3b91a4" />
        <stop id="stop478-123230841248" offset={0.53} stopColor="#25738a" />
        <stop id="stop480-123230841248" offset={0.97} stopColor="#024261" />
        <stop id="stop482-123230841248" offset={1} stopColor="#003f5e" />
      </linearGradient>
      <clipPath id="clippath">
        <path
          id="path390"
          d="M164.07 395.86s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-1">
        <path
          id="rect393"
          d="M123.48 382.39h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-2">
        <path
          id="rect396"
          d="M123.48 382.39h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-3">
        <path
          id="path400"
          d="M160.62 362.95s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-4">
        <path
          id="rect403"
          d="M120.03 349.48h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-5">
        <path
          id="rect406"
          d="M120.03 349.48h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-6">
        <path
          id="path414"
          d="M276.78 366.41s.34-3.78 3.03-6.27c0 0 .03-.03.07-.06.12-.13.22-.22.29-.28h.01c1.39-1.18 4.31-2.04 8.04-2.41l-.14 1.79c-.07 1.3 3.2 2.54 7.32 2.78s7.51-.63 7.59-1.93l.11-1.56c2.54.65 4.58 1.49 5.81 2.43.11.09.34.27.64.58 1 .99 2.75 3.14 2.92 6.35.23 4.16-2.39 6.88-2.91 7.38 0 0-.02.02-.04.03-1.29 1.05-6.56 4.29-16.5 3.14-5.87-.68-12-1.4-14.81-6.02-1.68-2.77-1.46-5.75-1.44-5.94Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-7">
        <path
          id="rect417"
          d="M271.76 352.39h45.73v31.23h-45.73z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-8">
        <path
          id="rect420"
          d="M271.76 352.39h45.73v31.23h-45.73z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-9">
        <path
          id="path426"
          d="M215.02 400.3s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-10">
        <path
          id="rect429"
          d="M174.43 386.82h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-11">
        <path
          id="rect432"
          d="M174.43 386.82h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-12">
        <path
          id="path435"
          d="M213.14 383.49s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12-4.1.43-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-13">
        <path
          id="rect438"
          d="M172.55 370.02h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-14">
        <path
          id="rect441"
          d="M172.55 370.02h45.65v31.66h-45.65z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-15">
        <path
          id="path444"
          d="M206.69 320.81s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-16">
        <path
          id="rect447"
          d="M166.1 307.34h45.65V339H166.1z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-17">
        <path
          id="rect450"
          d="M166.1 307.34h45.65V339H166.1z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-18">
        <path
          id="path454"
          d="M321.39 383.21s.35-3.77 3.05-6.26c0 0 .03-.03.07-.06.12-.13.22-.21.3-.28h.01c1.39-1.18 4.32-2.03 8.04-2.38l-.14 1.79c-.08 1.3 3.19 2.56 7.31 2.81 4.11.25 7.51-.6 7.59-1.9l.11-1.56c2.54.66 4.58 1.51 5.81 2.46.11.09.34.27.64.58 1 .99 2.74 3.15 2.9 6.36.21 4.17-2.41 6.87-2.93 7.37 0 0-.02.02-.04.03-1.29 1.05-6.57 4.27-16.51 3.07-5.86-.71-11.99-1.44-14.79-6.08-1.67-2.77-1.44-5.75-1.42-5.94Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-19">
        <path
          id="rect457"
          d="M316.37 369.23h45.72v31.26h-45.72z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-20">
        <path
          id="rect460"
          d="M316.37 369.23h45.72v31.26h-45.72z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-21">
        <path
          id="path465"
          d="M327.39 287.08s.35-3.77 3.05-6.26c0 0 .03-.03.07-.06.12-.13.22-.21.3-.28h.01c1.39-1.18 4.32-2.03 8.04-2.38l-.14 1.79c-.08 1.3 3.19 2.56 7.31 2.81s7.51-.6 7.59-1.9l.11-1.56c2.54.66 4.58 1.51 5.81 2.46.11.09.34.27.64.58 1 .99 2.74 3.15 2.9 6.36.21 4.17-2.41 6.87-2.93 7.37 0 0-.02.02-.04.03-1.29 1.05-6.57 4.27-16.51 3.07-5.86-.71-11.99-1.44-14.79-6.08-1.67-2.77-1.44-5.75-1.42-5.94Z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-22">
        <path
          id="rect468"
          d="M322.37 273.11h45.72v31.26h-45.72z"
          className="cls-1"
        />
      </clipPath>
      <clipPath id="clippath-23">
        <path
          id="rect471"
          d="M322.37 273.11h45.72v31.26h-45.72z"
          className="cls-1"
        />
      </clipPath>
      <style id="style182">
        {
          ".cls-1{fill:none}.cls-4{fill:#ae5a80}.cls-5{fill:#db6d9c}.cls-6{fill:#04b5c7}"
        }
      </style>
    </defs>
    <g id="Layer_4" data-name="Layer 4">
      <g id="g634">
        <path
          id="path490"
          d="M191.21 88.66 91.9 114.34c-9.3 2.41-18.61 4.81-27.91 7.22-.34.09-.66.46-.63.83l.69 8.15c.63 7.36 1.25 14.71 1.88 22.07.93 10.87 1.85 21.74 2.78 32.62 1.14 13.32 2.27 26.63 3.41 39.95l3.72 43.59 3.75 44 3.51 41.18c.99 11.55 1.97 23.1 2.96 34.66l2.13 24.93c.34 3.94.64 7.88 1.01 11.82.02.17.03.34.04.51.05.56.51.97 1.08.83 39.08-9.61 78.17-19.21 117.25-28.82 11.07-2.72 22.15-5.44 33.22-8.17 1.07-.26.62-1.91-.46-1.65-39.08 9.61-78.17 19.21-117.25 28.82-11.07 2.72-22.15 5.44-33.22 8.17l1.08.83-.69-8.15c-.63-7.36-1.25-14.71-1.88-22.07-.93-10.87-1.85-21.74-2.78-32.62l-3.41-39.95-3.72-43.59-3.75-44-3.51-41.18-2.96-34.66-2.13-24.93-.66-7.78c-.11-1.31-.07-2.75-.34-4.04-.04-.16-.03-.35-.04-.51l-.63.83 99.31-25.68c9.3-2.41 18.61-4.81 27.91-7.22 1.07-.28.61-1.93-.46-1.65Z"
          style={{
            fill: "url(#linear-gradient)",
          }}
        />
        <path
          id="path492"
          d="m278.22 92.8 102.8-.06c9.68 0 19.36-.01 29.04-.02l-.83-1.08-18.39 113.67-18.39 113.67c-3.44 21.24-6.87 42.48-10.31 63.73l.83-.63c-29.75.03-59.5.06-89.24.1-8.43 0-16.86.02-25.29.03-1.1 0-1.1 1.71 0 1.71 29.75-.03 59.5-.06 89.24-.1 8.43 0 16.86-.02 25.29-.03.34 0 .77-.26.83-.63l18.39-113.67 18.39-113.67c3.44-21.24 6.87-42.48 10.31-63.73.09-.54-.22-1.08-.83-1.08l-102.8.06c-9.68 0-19.36.01-29.04.02-1.1 0-1.1 1.71 0 1.71Z"
          style={{
            fill: "url(#linear-gradient-123230841248-2)",
          }}
        />
        <path
          id="path494"
          d="M389.53 408.85c16.32-100.84 32.63-201.67 48.95-302.51-9.47-4.82-18.94-9.65-28.42-14.47l-47.1 291.07c8.85 8.64 17.71 17.27 26.56 25.91Z"
          style={{
            fill: "url(#linear-gradient-123230841248-3)",
          }}
        />
        <path
          id="path496"
          d="m80.26 134.42 134.03-34.44c-7.13-3.62-14.25-7.23-21.38-10.85-42.9 11.08-85.79 22.17-128.69 33.25 5.35 4.01 10.7 8.03 16.04 12.04Z"
          style={{
            fill: "url(#linear-gradient-123230841248-4)",
          }}
        />
        <path
          id="path498"
          d="M93.13 281.5c-4.29-49.03-8.58-98.06-12.88-147.08-5.35-4.01-10.7-8.03-16.04-12.04 4.67 54.08 9.33 108.16 14 162.24l14.92-3.12Z"
          style={{
            fill: "url(#linear-gradient-123230841248-5)",
          }}
        />
        <path
          id="path500"
          d="M107.11 449.33 94.72 307.58c-5.35-4.01-10.7-8.03-16.04-12.04 3.81 43.43 7.61 86.87 11.42 130.3 5.67 7.83 11.35 15.66 17.02 23.49Z"
          style={{
            fill: "url(#linear-gradient-123230841248-6)",
          }}
        />
        <path
          id="path502"
          d="M438.48 106.34c-47.54.41-95.08.83-142.62 1.24-5.88-5.21-11.76-10.42-17.63-15.63 43.95-.02 87.89-.05 131.84-.07 9.47 4.82 18.94 9.65 28.42 14.47Z"
          style={{
            fill: "url(#linear-gradient-123230841248-7)",
          }}
        />
        <path
          id="path504"
          d="M107.11 449.33c46.66-15.37 93.32-30.73 139.98-46.1-7.89-3.39-15.77-6.78-23.66-10.16l-134.03 33c5.9 7.76 11.81 15.51 17.71 23.27Z"
          style={{
            fill: "url(#linear-gradient-123230841248-8)",
          }}
        />
        <path
          id="path506"
          d="M389.53 408.85c-40.13-4-79.27-7.29-119.4-11.28l-21.7-14.5 114.53-.12c9.18 8.87 17.38 17.04 26.56 25.91Z"
          style={{
            fill: "url(#linear-gradient-123230841248-9)",
          }}
        />
        <path
          id="path508"
          d="M209.76 100.36c1.57-.09 3.14-.17 4.71-.26"
          style={{
            fill: "url(#linear-gradient-123230841248-10)",
          }}
        />
        <path
          id="path510"
          d="m60.95 106.71 86.74-21.63 86.5-21.57 48.7-12.15c.96-.24.55-1.72-.41-1.48l-86.74 21.63-86.5 21.57-48.7 12.15c-.96.24-.55 1.72.41 1.48Z"
          style={{
            fill: "url(#linear-gradient-123230841248-11)",
          }}
        />
        <path
          id="path512"
          d="M55.13 92.59c18.73-4.67 37.46-9.34 56.2-14.01s37.3-9.3 55.95-13.95c10.58-2.64 21.15-5.28 31.73-7.91.96-.24.55-1.72-.41-1.48-18.73 4.67-37.46 9.34-56.2 14.01L86.45 83.2c-10.58 2.64-21.15 5.28-31.73 7.91-.96.24-.55 1.72.41 1.48Z"
          style={{
            fill: "url(#linear-gradient-123230841248-12)",
          }}
        />
        <path
          id="path514"
          d="m407.47 408.27 14.4-88.23c4.79-29.33 9.58-58.66 14.36-87.98 2.7-16.51 5.39-33.02 8.09-49.54.16-.97-1.32-1.38-1.48-.41l-14.4 88.23c-4.79 29.33-9.58 58.66-14.36 87.98-2.7 16.51-5.39 33.02-8.09 49.54-.16.97 1.32 1.38 1.48.41Z"
          style={{
            fill: "url(#linear-gradient-123230841248-13)",
          }}
        />
        <path
          id="path516"
          d="m421.92 408.68 9.33-57.16c3.1-18.97 6.19-37.94 9.29-56.91 1.76-10.76 3.51-21.52 5.27-32.28.16-.97-1.32-1.38-1.48-.41L435 319.08c-3.1 18.97-6.19 37.94-9.29 56.91-1.76 10.76-3.51 21.52-5.27 32.28-.16.97 1.32 1.38 1.48.41Z"
          style={{
            fill: "url(#linear-gradient-123230841248-14)",
          }}
        />
        <ellipse
          id="ellipse518"
          cx={293.12}
          cy={389.47}
          className="cls-4"
          rx={8.34}
          ry={3.59}
        />
        <ellipse
          id="ellipse520"
          cx={334.27}
          cy={388.22}
          className="cls-4"
          rx={4.72}
          ry={8.34}
          transform="rotate(-87.03 334.266 388.218)"
        />
        <path
          id="rect522"
          d="M130.34 221.1h14.92v199.46h-14.92z"
          style={{
            fill: "url(#linear-gradient-123230841248-15)",
          }}
          transform="rotate(-5.94 137.771 320.81)"
        />
        <ellipse
          id="ellipse524"
          cx={127.5}
          cy={221.82}
          className="cls-6"
          rx={7.46}
          ry={2.36}
          transform="rotate(-5.94 127.447 221.809)"
        />
        <path
          id="path526"
          d="M180.56 198.13c-.1.09-.33.29-.61.6.16-.2.37-.41.61-.6Z"
          className="cls-6"
        />
        <path
          id="path528"
          d="M147.74 238.86s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12-4.1.43-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-16)",
          }}
        />
        <path
          id="path530"
          d="M150 260.65s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12-4.1.43-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-17)",
          }}
        />
        <path
          id="path532"
          d="M165.95 412.66s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-18)",
          }}
        />
        <g
          id="g540"
          clipPath="url(#clippath)"
          style={{
            clipPath: "url(#clippath)",
          }}
        >
          <g
            id="g538"
            clipPath="url(#clippath-1)"
            style={{
              clipPath: "url(#clippath-1)",
            }}
          >
            <g
              id="g536"
              clipPath="url(#clippath-2)"
              style={{
                clipPath: "url(#clippath-2)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABDCAYAAAD6WNkVAAAACXBIWXMAABcRAAAXEQHKJvM/AAAXPElEQVR4nO1cW9BfVXVfa58/MQFSIFiQCRdNJQmhYqThjphptdoL0FpsZ/rQmWrb6UxnsLHWts44TO0UdTojfehDO0q1TqVILw9QW6oPxUvT+iABQiSJEWEELAJi0BBIvrNXZ++9rvt/vtwDM0wPfPnOdZ9zfmvt3/qttff5kIgI/n95WZbZKxX2z+/LAIjt90GW8xPC6gHrSb+wBF+yZ3zFef43R6qA7xypgj+1hBfu3p54R0HlF5ekun7tq9JxedZXFPgF9M+/WDze7XQGmHxR8qu2UVDx0JSesWZAuHbpcMye9yUBf9tze2Dbc883TBiMC3/sRFi3/MRjdo/i6bfsWQAs7fcOjzgNPEyDL5AoMsRHeMfqGcJ1S2ewZnZ0PeK4gf/g7j2wbfceuOOx7zEgCOU/AV/2vWvl6XDh8mKIZUd8r50LBLc8vx8q6gL8IpSj+xehGwjgk57rwS/7y+r1y2Zw3bIjD5vHFPwHf/Cj+vO5R59sYCesIAvQIOsOfFm/ac3ZR2yAj/9of+V67lr8Zv369FLfXuxBoRsE/gea6hVUt68/8QS4ftkJh/3cxwT8f3j4Cbj9299VcDGl5oSYADoDCPWYQdgQUAywEtadfPgG+N1nXwiGBXAe7o3ASwMVu23dsH3s8dEo5IAHNcDaEwb4o1OWHtZzHxX4t+16vAJvoDuQedsDjd16AJ/Bumn14RngX/fuh7v2LoQ25n7r29rq1FuT8oucw14Oi3i+iwXlv2KAPz710J/9iMD/7Dcfg9t2PWZAetBTUpDrvt4gBwBfft++ftUhP8tdz++Du55faIYGaUPeLsie+r95uXJNoP8eDr/dx4L6m3wvaQb4k9MOTUgcFvgPPLMbPrvzMdj6/eeCV3uQI/BiCJjvAUxN8/sRbnjNCviVM0+dfIbtL+yHHfuap9+5Zx/gkFwcSWpQBfgg3K8vr17sj02ArafPAw8sT9cuGeCDK046KJ6HDP4DT++GD2zeuoi3L+75/pwp7w/U5NpJw9Da0h9uO7FR3Xb9De4+FbiOgpw9DssASj29AnLnunXiGHDBkhl88PQDG+CQdNL7v3I/bH1mt1MnxpmoN2UP9zwJ5nxE3iFj4oPutxy3bdLWmrdh8Zj6G/g3Zdd4dpktRiDdE+syJTEhxATH610wBuft5NsggIde3A//8sMX4J3LFw/CBwX//V++D+5/erfhxS8U3ot4q5RRUvfeFFEonl0eEBfzyGCYZoIeLmlPgp43nkpHpEXcnCbu4YBzp+kZ3rv7c7364ceTY/+8e2/tARe8ahrmA9LO++65Fx546gfMz82z/brnb5ygkcj7aBThaWdIkYLkfPk9pHCdxQvXlqMrk7PtH5qQmmrkAKijEenZU8F2AnxvrOb5sbfcdu6KSXwXzY83/efX4f7vPWs6lxts2V3kRttHlQLiOe4YdT+hbedhvE80dOlRtV3XNvhzZX926/Unt3NyDvetj8X7QO5Prv0cr8ll3T9rju+Rw3MR0xJpfejPnnxuEuPJ/vDprd+C+578fvMydhzinqxCrbxXcpTsaEmP5dw8GSxFRwYdxfMkdhQXxbLdepUYt56P1FgEwDg+yU14ye0Ba+wpHk8d5zuFacaNh2DSs/12l2BhpJmpnlKWbXv3wTde2A/rlsYseM7zC+if3rpr3iOyeFauP7n+5n39ecEbc/SKHL0RKHoRdOeF4733iYfKPdjzs9927ZWeUK8Zu55AXc/K8b6Z+B5u/1QPCD3F9b7y+x+f3XNwz3/vF79W9XJMuanxbPXCwrW8O7cBC+BjwrnVpkm8sbxbhgRN1xdnTeIVOdu5QiXcRdApB6ye3s6nlMSB6/1rAE+icqQTYvRS130Rhd58T2gP6jNc8kWfRZKtxdanCnPbnn8RvrF3H6xbtmQa/Bv/43+Ys7J23QI0CVCuIhjUjoAAHMg8qExXmahtlg4D7XwxGpKBT6KaxGiYTEkNqLQVJGrmf1gE+BKyPpPIVd0WB7Izw5ryngu+rNT6PIA0frt38MbhtrYtBv6W/30Gtnz3aadk2JMzmjLQ4lXrGU1tsORGk4/1vGKQ6u3UDEEZMquWJkn5rdhQ1eBUlE1ux7AlTo3f+QVLm2KwlJy8JJcpk4GvzkJx3ZWeDTx0dRq3dJw+FwtcGwfuGQR3PPNDeNeKk+fBv3XLjqa/5YLUVaE4+La2uBcUPisQEdr5DFB9qDxCqmBT60Eje0ESTkpsFzGUSxQaEQMlbHvEaLXXpHYN38f6QANWjOETPqmctmO993Jm6lEVR5oCUn9RMII+NnQ9wEnDYoBfPX25gX/rvdthyxNPWQZbgQP1aggOVAKN8+DSaFkf2WApKReXnxKsmrOyjufgx0MrGguaQZMCaNtlrZg4230GVj2UtaCmlAMSexQe4/Po0IwxWiAPx2NgELVjUswlWC7jD/nCXLsED+55IYJ/7xNPVa0q795UH1Wvq+m8fxmhpeKVDHCLEQxwjRPMu2IAHTxJLnY076/HqsEKtqJOMtDYTkdwvYTvmZA0g6XREiySYDRXy++h93AY3aiT+eOKZNSs5E6giQkSU7lr2VfAl2VWgP/64081EKUuQl1txQHpG1Kvk7gA3GWyU0CpAV6vL9cMyYI5FWiRu1kLyvUcSB631p7EkoSQR3IDNnydr+fnpnDQU4c0OFfTN2UipQ+LAR09TZmQOkMc1AjNAD950lKY3fv4Uwx67K78ViFQqQEcfyYGwQIutjiQG9BFU/uyc6CGmiosAA6D4qKJR+L7F9KpwTfXe7EqbAZLzSmkt/YeX4WAr/ygW58Axjsw+ffmfZb8dW0E2plYugF4AR8v+as7yGot5h3q5W7oT/brQLjsY9UzVzLu6zGhZOxrOr5EnGzsNw1WK0qpXqPP5WpEAjj2sxRQ+65e4z1Se4avivpeYM6q96C5nW4rKKrumNtf/r3zDa+FmZdCUp2sN5aqIJr3o3oYy0fxokorLbkRaqgDG6yK6r7SLiWjDjFsQi5CtniRJHYgx4+6B2tiVgMvJqusOoNPcX5QKq60AUotiRMsCJQk1wXa8taZKpZOgb5Id5D9M9WuPhHxmllq9QnjS7FxMAm4aNRDvE6oYDUNz9dwTV5zBl5HfhYbIGEsi7EoQaoFLlY9QJNDhyIIlM5Rhg+9WJGKZnZea+VuoVQTNqh6yWpSJkntuujpodTtcxJeZloi8OWBzMUsMPnWst1kma3elA0AqEFKaKMda2kyFvmSmW5y4e6xtcc5RaGYlrrlEIjrfcsjDmSFNI5FKNtODNRnSxEBcnyBnnp6z1VBQZrzSPtaMhBDa7JG8+2EdZ9tx54wC+myH4CQOonj1PZApqnJGwBNb5dCgtixeTLZsF7r/5FuKlojq51GScQBG9k5UpW+xFTD8cIJgipXxatSTyGOJ7JTN2wIk5oY1NMkaaBf8b1Des7E+YvQz0yTB+Za4XxNEpABT5bRysua1d04Lr+gjKXqAEy7qIFaPL70gLElSUgDpGTxpd4+FRMOAdiSByCfV/cFeekoJEPoCbZulKLX+CKV9HIZEnUI+jbQKTat+4DESVuC8zq7yVkzkYJCj6p90Xa0XZL94nwvqJ6KDuTmweIN1RhcDW3liJbatPsyzQ1Je0S1tfD/INxvAytSsmi8P1iN3r9wB75qdjdJi7y49Gj3EpXjDqnosJhoPSsGaX0mnxtFizbP15qOpNpggxvRjtZAU0TgVAIqRbTul5xqaoDpg5bTsni/cOoAiJn5P7H8yzCU/UNTSly+hIzZGTrPU4R/Lv/y4ME3X0T1ePH73hhcv+JcR43FCi8wvSSebiaD3AsRwrkzKakSQADbInt8aHkkyypNooaX48KXeF3OBpgoBhxH1v4WOIsxdC6ODLaPlgskphtaGCHNGi2RlDRcISCJJHWiRxOv3JJD6Q3VCbwiSfNZEzonaw7mlKEzVi0eBkMYoi0fM7ZoakecQNDzFzhvIsd9wA8Z7C6VT+F7/wKI6qVSFq67aykiW1pf2syDJmHE+UFta4HqfJ72ZMjS091bwCnhG80A5JUcr1dnEMBF8YknCyTuGu3xblAJJDAHBvAGk1EnO0wOMFM76iUmsfyLiVAO/pAd5aBrhms9KG2L9OTExubdgCZaGWWApZw7AtGsHR7bBCq5AQ6KDOBo81Rqu8l6S30M7nmt17lnYIHQxJIHz/gaACyPUM4vhhljENWJWi5LluNjNkzUeQHeeOpJ4vnkslvQurZPHHypwQ9M+OPkuq3KP8lAa2YroqCVK4tnK11w4ax6O7UAmzVIJyv4sUvL1JHCUbWddsDiSpIhQzQJigamAKu5C0oNMKkh/PyioKDQ6klKxYTRYAopOdxAJwhcxB+FONqhAGgfar2GVfWgx7rEhcsJUkIogAsILeNtg9g2QMLX0gBUIzBUPm9TzHP1/tqByhRCbg/Ei0er94zcA3xvFLopzys0VJ9/dLHJO5PofY4JSeKWljMsjllZQwxTOZff3N1fB3e8ezu1A523B5Lxagrn4nu7mecdf448wChKyIb8aByNiwt4Yw5pPmmXBu4ZQ8sV+MVboETrRTiRwWrhr1Db2OgJu6xcvDbbeGyTx+WxO6EQQCe9p8nKUZ1P4ogmWvyebzzlZPP8qbpEl3e4gWY0UKeSN7SLgopBp0pUZwuqAoJJv0z28PLy48KoXll/OFDmBVeJRYtDNXFLbEimFXRUkAb3fNXLB0uwUIBFTgyxlrY9+CLPE0jgt1l9JFm0iylikPWnMvhZaGdqIMD/dmOTloDJpfZCKunq5mgGARuoUG8XcHNSI0g7tADs0VTr/RKMSWLBbFA+TtwDkJ9FAnRVPDxWUK7LbDQxVJb4wY5CPFNDxihaPDJeD/LSj9SRPXdQK+gSMgb+N1edpfjOQqG/Q5+cxJK5LUDzAdm83hWRgtXjOXYeqyRsBTQdfWJurZ5eV8dGMeRiysJCBbYE5qHo/WSDPzhmBdB6C+rsBx1T4FG21mS2QC69ToD34GPrPVLpJV9akekleVRqtUGqZoD1py038LOonc4A4u0xEGfrBcZCzaudVp6jMektbrBbJa4GNJc9ynk+SUlGScDfesH+BfbgBZ6WaJNvczJubwaRibpOrfWTdHlkbpQSdzJHSazYKvB9RXeU3uJG93TSlvdmiOADCeejXSCKRyZHoXC+WSZOi5iPFYa58T2NWY2lC0/dE3B1kAVR6/bASZXU+es8zYxa8KuJGntubWUE/bgCODGq/K8yFVTCVmpDrq4WqsqWCEp9qoCZVQX52MLTOywva20UA/j4wwrv3eefE2wxu/R1K+Fr3/rO5BQ3mTkcZnDpMdCpE730tOAMOnNB2qrFtSxgSzC0WBASO/dDMpcFUXm8BtXZwF290U916gJWzjWACt2Q0E3ZL+WEqrt5XCF3X9oU7+diYZn+opk5936bKi+9YOTst7FF1owYoc2OQXj3+WdH8G9862Xw67u+A6r3vYKRqXne6yUWUGcIphJJiMgbUqRWpaeWQEnQJp1j6ebWpGRj1Ow9TRiIMRaMuyv3C3W1dxjEIEk4PtXg3wI31ECbZjO2ZaOi8NlRZpCRCwTuSxlJqFDK5hInNKhKpDWlVF76PWvPg36ZXbbq7Dhj2HGGlJcFfGOn+A1qDBkyBcOoKfQqCdSI8X4VFJ5iwro589ST5rDkBs05VlSPLe/GKqZ6n0nD4n01WeOJWWnMKlOJ9tugfKEJYmWVebhTesJgszKQSI0uQ6dagChFP5Tx5xaQEzvLxa8+Bd6z5tx58Ms/N77tcvjLuzfPT42TeYrd1IdIT/2HEDrPVXM5kYfRGKhTqUHiCnWxQzN1CWyjlQec1EQGGaR0XUDmL1o8/YCMI1CbF5pmrTpb76cf4Lmx59TyjdgjCGSSHbUht1ZgzFhzc+V6odwE8FsTXl/fQT4LOm/TX9jAsH4Y4sDyVNN5s0226r7+kHNd9ZHAppZbOVvm3oPSleUD7Xf2k7ScxpYys4yOoUhITqJasLWvGoWS5Fq5po4hs0FBgrS0N6TI8dKe0FZVTaauRGSU7Q1nroC/fsubJsHXibK///Yr4ZZ//6p6r9Y55Gu7uYBMBp43BPmEzX00ARYXfMAWGso8y0yBlxignE+OX0EBauqHWmFtNjRlwhxeJxlSEVRUdXziUTEZsEnSEAfSplht2kt247zIdYck8pcVGnGmjZJQkRlgwxmnLQp8AH/TO66C/975aP0JlOMDbG8EWc/xPI0HU8e0Nzg6YykrYd1TUWZllEVBDZYIiXeSGKFcV5VQZiribc6CM9jgSeV15nuZ+ok1zpQ2uUrHxyt1gdRwWs9NvF5LHMSKRgbkeWrp71x44C/pw8cRm37uati84xEGxnluWHef27AGoK4XhJ7iBrYp0Fr3WY7neekF7P20wF5WJ8YutC5dQc08C3qoLl48vvB9laIF7AUGahh0tnXV4DDwFwEtsLJ9mjNzoG9ZK/cwnlEhaqcaPHwAgjzzmutHAPCJn7kEfuqM0w4d/CvOPxeueP05sHnHo3MgAZcYGubZ6KV+8TffS6j7gk+P5a4HdEGdXGZYhwslXuSYA2hiVuLBwMxDjVLaHIuhfX5EXKSDgdUKb5ex4dR6jwCbdO4n6bcAGnBlHinnECh1rMxlb7CYd+vPXgYbzpj+/NMvk9/h3vDxz8Dm7Y90QJF2ucj7ORTdvEfrx3Hge4w71wdgQP14TFWPV0DkaiTsbaDafLBgOxvm530OqfaOyvmsalowTVU1aYCeDRpcJZBacPV/ksCql3F+aYJP/fyVcMlrTj8o8LAY+GU567f/1IEXPVqzX+Vtp/XZONlzOrlcIVMEP2fNHwx4F/QxBjhfDW0G6JRNSZ60DNEASx7EYggBUQCVa/0xMaD7CDsFsOP+S1f+OPzexWvhkrNefUjAHxD8wv2//LFPGfDa/ck+qXTebjIT7DNQcPu7mADZBs29NNWMdwr8UC/x2WWr3VTABcABeVy3ebdKUvV81wOGpMfMUB58Pi8NIRMWY1y68gz4zHXXHDLoBwW/GmD7I/BLH/tbpReaA5rmthvwnULyyVQ4rzOganwL5O0pXb0cPP0kq2aKFq80M0yAN0Svd/sM3B7s6WOSS5T1v3/nT1evP5LloH/yZfP2b8P1N39yXql4Ps+dEfptih8Wz2fFnWF8PjEJfgoGsERHvJ893YGLPd9XimJDVI+36SrSGxR8bxRef+8VF8GNl7/hiEDX1zrUv7dz/c2fgK9ue7jzaPeVtaeV8AV4lyHPSUx/zG/LE/ZPHKudQj3m+RY8DXDUoJxkm2lEgvDQGyq5c5NR0+XnnQWbrloPl51z5lEBf1jgl+W/HnoYrv3w38wpmgho91l88HgvUWnCKKAGBBfE5+gm/PDAigNYjeE5XDhbDDI06mgAD87b5RxTROX3+zZugE1vXjxbPe7gy/LRf/oifPSOL8xTjPx9A+Cgm0066qANWe+IlKP/hJK2ge8H58XrPfc7yvEycfBBdzBQXYBt9OSu4/1X/sTZcNWqs+EPNm44lpjrclR/XfAjd3wBPvK5uwP9QPfHIELAFSmZXWLmpWo3TqDjj556pmiHPR+8DPSUMwzBo+cCsNv3gXdcWdf/8K2XHRuED7Ack7+refPtd8NXHtwFX35gpwM5d71iimY6WoJYtg5jktgDL9vJGSAFPsdJyonr16x9Hbx57Wvh6tXnwdWvn6+5H8/lmP853z+/7d+qEb50/w6mmDwBdidZc5i2FoH3Wn/OAEI9SQtuCr6M4TptX/Z/6Ia31WuuWbuqgv5yLsf1D1kXI1RD3LcDvnTf9kWCrCVgcCDv9zMbvBHcMF4Ntkw7G9evgbdctLoGzA/92ttfVpAXW17yP+H+4b+7U8G9Z8tDcM+9D81TTu/9sgS6Adh48TrY+KYLdN9Nv3HdS/kqR7cAwP8Ba2+fYsKdLXUAAAAASUVORK5CYII="
                id="image534"
                width={97}
                height={67}
                transform="matrix(.48 0 0 .48 123.04 381.92)"
              />
            </g>
          </g>
        </g>
        <path
          id="path542"
          d="M162.38 379.11s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-19)",
          }}
        />
        <g
          id="g550"
          clipPath="url(#clippath-3)"
          style={{
            clipPath: "url(#clippath-3)",
          }}
        >
          <g
            id="g548"
            clipPath="url(#clippath-4)"
            style={{
              clipPath: "url(#clippath-4)",
            }}
          >
            <g
              id="g546"
              clipPath="url(#clippath-5)"
              style={{
                clipPath: "url(#clippath-5)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABCCAYAAACo/NMFAAAACXBIWXMAABcRAAAXEQHKJvM/AAAC0ElEQVR4nO2cO1bDMBBF7SwgRWhThoYmJSyAhk1kE6yDTWQTNCwAyjQ0pEwbimzAnDEosWzZ1mekUcy7DZwT4s88zWgsrFdWVVUVE2S7PxTbr4PXja0X82J9M69/36yW0YJTElMTYPd9qgNPPznZ3C5/hVnM2Y46OQEo6M8fn9HPwyVGEgEoKGpUtlGpzpXmj6/vLMexhYQIufZoAgwFvY/Qm6GRz112bPG9dnYBQia+4i8jXu7vvL6bevSboGt3KUtsAoQGvomPCJznD8VFBIr/LOR8dOM08jhvvi5de7fj7Y4ypceEayn0yoAUI+7t6WH0b3zmmlTYZIJzCYrVY5toPgxp13A8iU22royJ4CRAqh57agyJYD0HUOARfD/GyuOoAJL99RQYayoGBaAvIvjhDM2bvQLk2l1cK32xNAqACZcf1TK3MQqA4MfBlAUdAVyfQoE9pizQBEDdj087vpoACH582llwFgAtZzqMAuS0ojh1mrGuBehrkUAcOhmA4KdHxbwWAJNves4CYPTLoOYBCCDEJQPQ/YiCDBAm6K0IEA4EEAYCCAMBhIEAQqhXVSCAEOqlMwggDAQQBgIIoTZ0QABhIIAAtKVJMePcdgnsaMZ8ZnoHH8RFEwCxTkuz/BCzmFvxQZd2vOsMwDyQhvboL5QApg8AP6ZqgwxIRN/e5/MkjCyIx5Cxx0WA1RKZEImhwa21ocgCfsb2CmsCcBsS/Xdsdst3HsR83UqAju1gNj4JQ4QwqJTbxtAoACmH+cAPCrzL6kLvWhC6IndcDZsKG7saWBWM4+v0Ze2WAhHMqFLtWymc7Goggk6oyWCRu2FTrnAEXuFt2peTSV4KQktNH8GuiVMWQlmmxVwdyNK2UhL17JPqv4Tsxq05uxiaUAGXWgOL6h2txMjB5bDpwJjTgmNS9/TmbvxYGdK2usz9hYNs7Ot9PYquffm8LMvyB7XwrWYf9DkJAAAAAElFTkSuQmCC"
                id="image544"
                width={96}
                height={67}
                transform="matrix(.48 0 0 .48 119.68 349.28)"
              />
            </g>
          </g>
        </g>
        <path
          id="path552"
          d="M159.39 349.33s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12s-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-20)",
          }}
        />
        <path
          id="path554"
          d="M157.62 333.17s-.52-3.76-3.32-6.12c0 0-.03-.02-.07-.06-.12-.12-.23-.2-.31-.27h-.01c-1.44-1.11-4.4-1.84-8.14-2.03l.22 1.78c.13 1.3-3.08 2.69-7.18 3.12-4.1.43-7.53-.28-7.67-1.57l-.18-1.55c-2.51.77-4.51 1.7-5.69 2.7-.1.09-.33.29-.61.6-.95 1.03-2.6 3.27-2.62 6.48-.03 4.17 2.71 6.76 3.25 7.23 0 0 .02.02.04.03 1.33.99 6.75 3.98 16.63 2.36 5.83-.96 11.92-1.96 14.51-6.71 1.55-2.84 1.19-5.81 1.16-6Z"
          style={{
            fill: "url(#linear-gradient-123230841248-21)",
          }}
        />
        <path
          id="rect556"
          d="M199.77 282.77h199.46v14.92H199.77z"
          style={{
            fill: "url(#linear-gradient-123230841248-22)",
          }}
          transform="rotate(-86.75 299.494 290.232)"
        />
        <ellipse
          id="ellipse558"
          cx={305.14}
          cy={190.85}
          className="cls-6"
          rx={2.36}
          ry={7.46}
          transform="rotate(-86.75 305.141 190.85)"
        />
        <path
          id="path560"
          d="M284.49 230.69s.34-3.78 3.03-6.27c0 0 .03-.03.07-.06.12-.13.22-.22.29-.28h.01c1.39-1.18 4.31-2.04 8.04-2.41l-.14 1.79c-.07 1.3 3.2 2.54 7.32 2.78s7.51-.63 7.59-1.93l.11-1.56c2.54.65 4.58 1.49 5.81 2.43.11.09.34.27.64.58 1 .99 2.75 3.14 2.92 6.35.23 4.16-2.39 6.88-2.91 7.38 0 0-.02.02-.04.03-1.29 1.05-6.56 4.29-16.5 3.14-5.87-.68-12-1.4-14.81-6.02-1.68-2.77-1.46-5.75-1.44-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-23)",
          }}
        />
        <path
          id="path562"
          d="M275.68 383.28s.34-3.78 3.03-6.27c0 0 .03-.03.07-.06.12-.13.22-.22.29-.28h.01c1.39-1.18 4.31-2.04 8.04-2.41l-.14 1.79c-.07 1.3 3.2 2.54 7.32 2.78 4.12.23 7.51-.63 7.59-1.93l.11-1.56c2.54.65 4.58 1.49 5.81 2.43.11.09.34.27.64.58 1 .99 2.75 3.14 2.92 6.35.23 4.16-2.39 6.88-2.91 7.38 0 0-.02.02-.04.03-1.29 1.05-6.56 4.29-16.5 3.14-5.87-.68-12-1.4-14.81-6.02-1.68-2.77-1.46-5.75-1.44-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-24)",
          }}
        />
        <g
          id="g570"
          clipPath="url(#clippath-6)"
          style={{
            clipPath: "url(#clippath-6)",
          }}
        >
          <g
            id="g568"
            clipPath="url(#clippath-7)"
            style={{
              clipPath: "url(#clippath-7)",
            }}
          >
            <g
              id="g566"
              clipPath="url(#clippath-8)"
              style={{
                clipPath: "url(#clippath-8)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABBCAYAAAAuaKGrAAAACXBIWXMAABcRAAAXEQHKJvM/AAAUyElEQVR4nO1caaxdVRVee98XtVJksICVAkIRSqmoYEVFEYcgUSOoOEWNf4xD1MRoosYRjbPRxDjEP06IiqgJjpGosUWEQoggHQBLS5mKKNCWDiD27m32sNb61t7nvr7XPtBED8M9093nnPWt9a1vrX3uczHGSHO4rNv5AP30rq10/a5/5kGdc/KZVnGb8j4nF8d1XpbMewS9//CD5/IW83Lj/Q/SDQ88qDsi0fHzHpGv93AucwLAuh3307odD9BP7tpijOq6dTB82dkZ/aEG4Wdbdhbj3/8gRYJHh9WzD55PFCOd89j95+Sa0y37BMCPN99LF915DznvOmP3QEz2fmP0dIjmHoRk9M9t3iLbxvikALA5+DNdd8mjH0kvf4jA2CsA1m7fRR+74fZsVDZkMepk4zo5j3T/NCDoqm4kAPaGIlrj0ywAwM8TEhALHpM/52qZFQBr7ttFP7rjblq3fRcYfphWBg1cvRuBI4iQxvL1Q/ftTRQkqvl8Y3xqAWiMTy0AsZ5fP0+Y90h6xSEH0An77TsQUzM9MRn/I+tuAaPxnbt8k2kzOjUXPkz6TjknIZAewSXky7fzQJFiTCBEC0I1FI+ajDnbJXF+72FDeyYYn6zx079JaKT/UiQkEF556IGzvi+xzUwiYM22nfThtZvUa11LKbCO3o+JuE3M5d+cP4hwHEL31xutG+ccPL8kyRksyfgX37ujM7XZ4sePzb7qIF0EDFDT0gzCQbR0/qNmZXyaCQDJ+B9ac7MYrwWBDL/3AOHxwTEaeqKWjpp8zJvnHLznpHjxlp2D3m7ZJ/bGRxBiPWuC8etKXv/o4oW0dP68Pd6XeZ7pAFidjH/dRjCONWBnbF6nNkp67zc5Yy9BmMnedrd53AHDq7cPG99EBqnxeYxzDzuIXrVw5nlqIgCrt+6gD04wPlXq6A1NQkctAKJyOlAG5CmcN2TQCaaeCE22ahorAtNP8noiY3wGZCgCBIwQZMy0Z+l+8+i84w6feJfmjicB8NIV1xqqoFnq+yEQrLf3vO9akBH49sYHbB0b1dRaun3STvWgpxNGQM//gk8MqqIgT5w4fx6dd/yi6WxfnmMIgA9csz5HgPFCQzW9tm+9Ny3e+yaC/MT8oV9zNTFTF2HTP8nwrti4/EQQhjx8kvFRtmYw4BwA58T959HHlxwx7W13MvS6LdvpL1u22+fJ6tEZqSYPV0QMRZcMrv5WjodyQAYLenI1rC2ICpgxxAqUytzOuAYQpgobAbFZM/Tf0Ejv/dFGSPon2GgaBI/HjEm676S19+2iEx/z6N7y/BxtBJz1u6sbGkh87xUISLI9309QPwNFmknGQ1EAspbvAyNv2kWKEeGlwSILAUBA8ByMADsGgoe5ItoxItEnlh5FyyaA4HHjgg136IVEhsWcZORGQjTn5ATENxOjHMeb5rC12/W8UMev1ygP2ZwT+yQ4eJ+o6SdcLw48V/+88KzBjq3jhMFnIxlKQflIqqFmEgFnXnJVr3oG1Ql7o5NiqssVIidbiVpzgUfZ2RZo01yfmqiAbXVPUtdvK1rjwpMLrfbYYA0QaXidrDOk9RQBn1x2dAeA5IDv3XS7tAu4/MdP4ViPz1blXab6qNTkGuqHnFH2B3LBKiwZ09X2Qzrm8VhkdPNA+aOMahMPPzQfbXgcAWIaQYP3agj43xEAQnrtjqJ6AK7buiMXtcsO2M8AIBHwwl9fMbE7qYaaIDvTRq0LzLldrcBj1HG8t/sIWxlNNDWKaVCHmkXVCquFNgJ6Xh+gMIo9iBMiBXMCgs3XedIB8+nTJx1j7jJHwHf/eptNQsW96oOWAVpVUhpsxTOzYcYxg1AabdVAoW4zZdXGW/rMjbsYjISN4t0WBI6IfN0EWr1PVVHO3jtELEic+izqoW1V3FbDfeHVN+YEFoimIboqUbCdVm/bkYEwAFx7z9ZKPzWs680SaHGhJx7UFZ+qSaBsh3qOq53NylcR+b8qKieUoIBi9JSRBrw8JU7SDqsOZlVM59GtdGxoYshgQ+AM1QoK9uScwcv3N/2NPvvkYxsA/rFtsGciHsb0ZyrUWL040Y/q/fwR6zFXSnSOnhIdQZN2I1s10pp84OHmwOE1SmOzDd7aGrDxYMlzIeo6FFfmO1BodfmlTcryPaC/WOqsVOQ+6cASBVPX3r1Nv+zgKRxGglU4cnNOkzB6uvRdqtdHVkNU9nnyZYx6fqqYQ0rM+TyvtMaAR80n+D1euEjkiFFjQAEGfaBBiqDpvReNLyO3kTIIdntOzCAIANfcvbUfhPSG2SP5gpxAC92y10eg3r7jWUBTbx8D5aTvWs8PwuMRzskgQPIXgzv1dPV43raGN1UvgZGRbULUPFWbbGqelpqidgNify0F19r1go2b6fVHL6wA/H2LSCwxhD2fJb8MqEFREnHidU0bajihHReBZihvS1RUuYl5wDUJ2XtX6RXoKFahOSSGGgBknY0flW4CdDIFEKr32NQIbCObO6q2xqrY3AoqKL2/FAUnHbQ/TV3zj62EZ0TXgsDc7QwIVCmlhMNY5nod0A+BVBVtL9QCFBRrYvbQxKu5JmZPhJmziPQzbW+6Gjt02MSayNGILU0ZjjdejF4f4fvW0Mzm3VRntc9f7r2vAJA8wKHsZE+DylYTj5NnlsHgitpEc6Xxxh7NstQzQFoHIAVlkEnHyf9Vw8dx9f7owElizT9lfPVebAcoPUmCNSzC1yfbbBsAwBF1Xj5E34Z2GjmvoJVlCkPKeH41MI7vKhcLVo5DU71auDyq9wceW/K7k0jha3rvlePhPSOOPFejsCsU8QFhu9XpvE8MLmCUYyHqQCqyoqEWk0qZihmPpgo399YCFYnOX387vXHx4TRVvA1OYgohp/JOETBeZvbLaj+Bk8GAfhHSnKsJJtGC1AiheL533oyVqQrAndQV7ZOu1fclPkG/E5koZ6Ck2MSEDReIDq9Bpk7q78kCwMsUDmCOcu8F4OVBuGVgEjMrl6DHpLVAGkmuGrVtWeecEcba1giOgg/S3sjnBM0bGEVtW4KNFoLeL/bzXVMR82NHOYb9JX6uiJvEA1vHnp6a5Lpg0ymZNOE7b2iIVUsZG+pX9mYZ3MnNi1dLw44ktEuFLDCWfaMmCecunMvvCqWv+5GHDit3NTzcTY3CwOKgUsqAIkGlx51LBcDyc4OoXqfZnrgwyIpQB8yU6N7mRs22Xk0SkcPvOK6So9INaZ9GokMxtFEQanUcChDRFZXiR6NyepKKbHRp+gXtD1XAQz2vM3qwyq5EQ1C14vpn1u5GQ/BgCX0+i5Oku8ahIyaLGOnae7aVJNzccS/RmktSB5m9cx8dF8dgaJWiUkA57h3FqoCC6Xai4UoOCaKMeMxWofHdhQjtaKQTiIJW0aDR2/YIn6uRj+rK2sM5CwbaloBNUgtoqvRAjMXldqQPlD1toAk2sI2jyHNL8QTrZmpTxynG9V21y5zPE/2+Fn9ctYrqqleVAgtuJB0P9S2GXNxVyeu9FonY4MNnEzvWHIZUhs5GhHK2OteQcSp4Uyq/Wv6D/ghAavhsAtoRNvIDgC18hLLaKKHqyePk4cEck8ZdohlfKLMAAeENBpd8xB4s9+qE90PQGw9jrrYHJndkTP6EOsIxL9hz1CfU29GZmIefuuDASkFQaMgDDVaBQyjCOgpjk+i0fxTGWqzxNURuirJRgD1EBIM0Go1ovHtsG3/QjKM6b4DdSNO/Iq0F2Ii7x30HwKG85k8Pio6qc6KGoV6Zcd0tZF6PPWXBATT11qc8kb7x5xvVWwZ1NHh3BNcHoFrwJqlhVwszBiAzvwvayczJ12UJmRt3rhg8gtuF8ViUXFJIhAYRr9jdtbr5JNFfTHmE9Y3Tji88mdgzMH2SsL/WPurGWkdEKFRZWapBSyUMvRHbgpWnKZKQoglTvoBUltzgijwPAF7YcJV6g8/5hT0/7R+PSc5L/7C3C+dyT4mIxv/andUSGykB50Ud1bqDtCfEM2rynOPa7og6BeQ8aDyW0JCrJI+CBJYogFopotEdKkhN/lNPW7igT6JQOeqdBLMPo6T6NvTBWTFE43moMIJ4XFD9DgpDG3cVP5xfxmZBSqgJMQE45YlaWbfvpVKZUSseH+TNjTR1KhRDpRJnShRHE59o2uLYWo9aKOY7aeuHgcJRAOB2spkNYmkfdRvfhTTFC0g8AcooJIiggVqDeDKmKhhu1uXtGCTpCki1dZGjwAzjqkIKMh5Jr8mqF6UbylHD/JSun8cgGzXiXPD6JI9j1p06YttfY6DevGxxASD97+2nnEBfu2qt8GcPQDB0pOPBNBxPXgRIOFGBMNWp03lmiSZOnNgc9EBLbFjSOOYpTzJGLQYq0nLM5spRwQ+fjc0NP27KQTOQaqHGnuox4iutxXFsIpYP2oksNZYtQp966EEKwNMev8BOuTEIAdaRR41KIokgpgQipDEqOiDyBvBh1DcV8vo4wP1GirujCfPgvMkvKVmL/ofeU77i2PabaGw93rxuWeeEeeJHgoFn8LhlLy+l1ef29mVkfWBomUNxiPMiJyMAyx9/iO2dgzHVy7GVK6pdpvDEwM28KjVtX6Epn9SMepkKASfJNOcLiAoHNJG8f/wvNVT2eEj0STk5lraoeMSrNZoZjBgAMAbA23ntSPyyR63em+nWSNw7cwNd37KcfJj+gEPejHvH8qX01SvXGAriBzfeaya34YcJHEHwPYmEus95BSOFMINdxuE2sK09kqFD/Q5XweLuIIlHIy9qLOMQgqkfqFLaSIyttOGilccoRXmSSEAGhjAJnmsSAUsdXyvnkofY+4mad0OXfPmHakzSF3HVkNFyO5NFbM6t0pPbwRSheqwgss5PlCKlu9PXQ0gmSbI1gTZUa8tD1KcdjTyxRsoFXOV1IyGblga2uxmkib9jkIkijVRqlFYPil6Dx7/6TS/pIyAt7zx1GX3litXGa3uv1lctDM9jtEB04Fic2AK8bR0EWFLQSb3GFnVjLZKcJlHO5DF4MUBuL4zqfIK8Asle6yn6IB6pBvZ11k0n/+VF4nSBsatv/6HhSRqLBgB+1bJJvm958nHWedrfB7zhot/SlbfdVV4bB+/fUzQIIBhB3evgUWgGk36Mdh/L18B5oa2sqzdKwpS3J7y0NRzLx7R/5KusVy/OspSTKJVzjDdLEvZZNeHb3K6EmCTg9jtEbaTod69588sMAN0vZN71zJNo1S2XaPKNA4ZsgQBDEtMR99yDBaMFB0HjyOBkzPMAAhITTFWY2D7I1W/KFzKV6cjXWiHW+QZfPTzRU25XB1+jwosMzh5u3k0NpfKOSGG1q+z5zUCoL3x1+1iiBZe3nXJ8a+4egFOPOIyevugwWnXrnRIFmoRbwzVGrFN3avQglGJ+5MEcn1RQtMdjpSVTVdexcqnBqqQeycZOBq0gpAcvHdMiV1ysdohJwpbcELif40L5jos0jnUeriZdjghUOfk3WI5fLraVNNcA8k69019kpWX5wkPobScv6QCY+CvJ1/3gN7Rq0+by8KE3eA8EQUIOHWWJgZnjo/2FikYR9dfg82MUpUJVFTl46ddzEVanODMleV53ZYaNZSh/l5MuvonhgZIGkq0z39X6wLQ+nNYI6bxvv+y5ud6aMQBpecKnvjnA8UPGtz/lMT9TEkUU7FhBkzR6f5RICrAOADEATD38INnYsH9UuZsNKkYreYLfN5L5Zq/JWo1MaszM+aCEat3h8TsChlVFyxcdSt8++7mDNp4WgFW33EmvOf9Xw96fjaLtBzQsR4EaHOgHz6l9JZaifCvB/F7MyfWYDrCrqgZzkGi9JlnnxOB6zMnbGeU8BEFfh2k9nVUT7ue+kMdtuR9HT0/Gf/kZk0y8578VkUB41Xd+YQEI9gdq1BhVAAkMXCivq9RXRRSchoJQHYligkhj72/7eOy9pB7LESBe6tV4RRUp/UhN4DkiFCT2dKQnpCIyEcMOoXXE+a98Pi0//NC9ByAtV2zaTF/6w9V0+c13KAD460GUl8D11EQLAsPen86Xl6Twe2QjTqpeuXMnGc45aFejgUYjLchYljZ0RChJUaLm7/ve64fAwIiA4+ef+4IcAdMts/qDTed+62L604bbjWxEI7f5QI53+SE0NATFXrD5QRuE0VBPXQEsnDGqVLwjSz8cCZyQkbIkCvJ6jQKJFqCsaQDgCLzg1S/ManJPy6z/ZNkXf38VfeH3V+Zejk3ExcMl2YYIFe9ABDA4IF3bxK79p3pxc6tND56LKu+7aBAK8t4kUXusUUN1PydpVjM9AP2YF7zmzCznZ7Ls1d+Mu3zjHfSF366iP224DYwKMjMZn3s8bd4IcQJNaaLWqU8EopuOYOs31Wjl4aayFYMC3dj8YKvhEjlWqlJtyMn5XpN1yjfPOGohff91L5qVLffpryYmOjr76xf1eUG8WUEIcrwFhvMIRotSDnZcZUVbpQoA1SINFQzqdDCaJO3G8zE3OEM/sI/Haajnwje8mE498nGztuGc/N3Qz11yOV22/la67K+3iicHpJnO88M0xo9qfOimmoW3ZVKFO41eIoDQkK4xbGNMlp6SiBGcRtIK5dTvvueMU+jdp5+817ab07+cm0D4zK8voz/euMnQEQKRc4SJFkzCYbLxOxXEn9qHR0+nNkmCDC0yddSAMpATOqA0Ut7zvOXZ+Pu6zPmfLublM7+8NNvsUz9foYYO5Z3NNPVokjIaPWIuAPWDt4kURJaK2gKKXG9A8WLgeY9gjfA8L7x/2uJF9KxjFtF7n798zuz0kAGAS4qIS2+4mVauu5lWXr/RRgXK0dAm3XYdR408HymGNwnZN5LUVLug/xuZ6ge8/31nPpNOW3wEPeuYmf0ZstksDwsA7XLp9QmMjdnYK9duoBVrbzINv7yg51dlZD6RghAI70zh1NKSKB0syhref85xR9Gzn3gkPfvYI+m0Y6f/i1f7uvxHAJi0rFi7gVauuakcjUQr1qynFatvknpgj3mgiYCWfsi5QW7/0Nln5M/nHJ8Mf9TD+sz/VQDsaVmxej2tXL1eLY/zHTUfnHfhb7Jhz3vtWbJfJldqo+z0pUfT6Uv6v93z/+V/bSGifwM37ftKpqjGLQAAAABJRU5ErkJggg=="
                id="image564"
                width={97}
                height={66}
                transform="matrix(.48 0 0 .48 271.36 352.16)"
              />
            </g>
          </g>
        </g>
        <path
          id="path572"
          d="M277.67 349.6s.34-3.78 3.03-6.27c0 0 .03-.03.07-.06.12-.13.22-.22.29-.28h.01c1.39-1.18 4.31-2.04 8.04-2.41l-.14 1.79c-.07 1.3 3.2 2.54 7.32 2.78s7.51-.63 7.59-1.93l.11-1.56c2.54.65 4.58 1.49 5.81 2.43.11.09.34.27.64.58 1 .99 2.75 3.14 2.92 6.35.23 4.16-2.39 6.88-2.91 7.38 0 0-.02.02-.04.03-1.29 1.05-6.56 4.29-16.5 3.14-5.87-.68-12-1.4-14.81-6.02-1.68-2.77-1.46-5.75-1.44-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-25)",
          }}
        />
        <path
          id="path574"
          d="M280.27 303.49s.34-3.78 3.03-6.27c0 0 .03-.03.07-.06.12-.13.22-.22.29-.28h.01c1.39-1.18 4.31-2.04 8.04-2.41l-.14 1.79c-.07 1.3 3.2 2.54 7.32 2.78s7.51-.63 7.59-1.93l.11-1.56c2.54.65 4.58 1.49 5.81 2.43.11.09.34.27.64.58 1 .99 2.75 3.14 2.92 6.35.23 4.16-2.39 6.88-2.91 7.38 0 0-.02.02-.04.03-1.29 1.05-6.56 4.29-16.5 3.14-5.87-.68-12-1.4-14.81-6.02-1.68-2.77-1.46-5.75-1.44-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-26)",
          }}
        />
        <path
          id="path576"
          d="M189.06 257.4c5.18 49.83 10.37 99.66 15.55 149.49l-14.84 1.54c-5.19-49.83-10.37-99.66-15.56-149.49 4.95-.51 9.9-1.03 14.85-1.54Z"
          style={{
            fill: "url(#linear-gradient-123230841248-27)",
          }}
        />
        <path
          id="path578"
          d="M174.21 258.94c.13 1.3 3.57 2 7.67 1.57s7.31-1.82 7.18-3.12c-.13-1.3-3.57-2-7.67-1.57s-7.31 1.82-7.18 3.12Z"
          className="cls-6"
        />
        <g
          id="g586"
          clipPath="url(#clippath-9)"
          style={{
            clipPath: "url(#clippath-9)",
          }}
        >
          <g
            id="g584"
            clipPath="url(#clippath-10)"
            style={{
              clipPath: "url(#clippath-10)",
            }}
          >
            <g
              id="g582"
              clipPath="url(#clippath-11)"
              style={{
                clipPath: "url(#clippath-11)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,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"
                id="image580"
                width={96}
                height={67}
                transform="matrix(.48 0 0 .48 174.4 386.72)"
              />
            </g>
          </g>
        </g>
        <g
          id="g594"
          clipPath="url(#clippath-12)"
          style={{
            clipPath: "url(#clippath-12)",
          }}
        >
          <g
            id="g592"
            clipPath="url(#clippath-13)"
            style={{
              clipPath: "url(#clippath-13)",
            }}
          >
            <g
              id="g590"
              clipPath="url(#clippath-14)"
              style={{
                clipPath: "url(#clippath-14)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,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"
                id="image588"
                width={96}
                height={67}
                transform="matrix(.48 0 0 .48 172.48 369.92)"
              />
            </g>
          </g>
        </g>
        <g
          id="g602"
          clipPath="url(#clippath-15)"
          style={{
            clipPath: "url(#clippath-15)",
          }}
        >
          <g
            id="g600"
            clipPath="url(#clippath-16)"
            style={{
              clipPath: "url(#clippath-16)",
            }}
          >
            <g
              id="g598"
              clipPath="url(#clippath-17)"
              style={{
                clipPath: "url(#clippath-17)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABBCAYAAAAuaKGrAAAACXBIWXMAABcRAAAXEQHKJvM/AAACuklEQVR4nO2cPVLDMBCF5Qx1CmhTQkNDCQeg4RK5BOfgErkEDQeAMg0NlGlDkQuYWWfkyD+yLGmltZP3zaSEyPt2VxvbekVZlqU6M16/vtX278B2Ueu7lXq4XlYfTgrinASgoFPwU8IpRjYBNr87td0fOlnJnVncme/i7fE+au1JBbAFvQ+6CC1GzPdtfnZxiw4gZu3sAlCwKQihWRiTUc/vn0F/xwWtm9bvA5sAsYE3CbkQqexv47t2iv9VzBdyBt78n/ThnjhyoIcAn5YUVAE5po2Pl6fJrCWEMe00qAXlmjQoi9a3q7oi2kyh5bhwieAlQIp2c+649oTRAky1zOfAkAgU/4XrGhD8OGwtVDMoAILPw9C+aRUAwefFNjRYBUDwebG1ol4BEPw09FVBR4DqJhpGzSSMqoA5/MCZM5TgJg0B0HrS007wWgDXvAr4MKugFgCtR4ZGBYA8mMleCdDeGEB6dMIfBUD7yU4tAFqPDPTCgoIAcpwqYA8BJEEFCON8IAPSAgGEgQDCQABhIIAwEEAIevFMQQB5IIAwEEAIeu9VQQB5IIAAegNWEEAG85X1hakGyENDAMQ8L+2EX+jdGOShfWKmqoA5HoibI32H0o8C3ECAHPSdlKkEQBtKj23YqTdhTENpsSX5SQBUQTKGTko2xlBfiwDgxnVqviFAClOiS6ZyUnF0ls4PMewFPIw17ugIoP1vQDg+rim9tyKobNCKwvC2rBmyKshtATZ3fA2nnFYFaEXj0FkfZFs2xqwDlWBH2+qE4GVXAxGahFirtfE2bJqKN5skHA6PmmDTvkushphWYyPKNfESHLRSWRZrWGwrz0mIKtg3y2y3ZNiNW33ccqeCHrUl7gZPxro4Bzq71YRuOmZ1T9eHwXNMUeYPyCk/5xC3rx8yCDGrx8zePub6MKkoiuIfH+CibYfO48AAAAAASUVORK5CYII="
                id="image596"
                width={96}
                height={67}
                transform="matrix(.48 0 0 .48 165.76 307.04)"
              />
            </g>
          </g>
        </g>
        <path
          id="path604"
          d="M341.01 238.87c-2.98 50.16-5.95 100.31-8.93 150.47l14.89.9c2.98-50.15 5.97-100.29 8.95-150.44l-14.91-.93Z"
          style={{
            fill: "url(#linear-gradient-123230841248-28)",
          }}
        />
        <ellipse
          id="ellipse606"
          cx={348.47}
          cy={239.35}
          className="cls-6"
          rx={2.36}
          ry={7.46}
          transform="rotate(-86.54 348.447 239.354)"
        />
        <g
          id="g614"
          clipPath="url(#clippath-18)"
          style={{
            clipPath: "url(#clippath-18)",
          }}
        >
          <g
            id="g612"
            clipPath="url(#clippath-19)"
            style={{
              clipPath: "url(#clippath-19)",
            }}
          >
            <g
              id="g610"
              clipPath="url(#clippath-20)"
              style={{
                clipPath: "url(#clippath-20)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,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"
                id="image608"
                width={97}
                height={66}
                transform="matrix(.48 0 0 .48 316 368.96)"
              />
            </g>
          </g>
        </g>
        <path
          id="path616"
          d="M322.55 366.34s.35-3.77 3.05-6.26c0 0 .03-.03.07-.06.12-.13.22-.21.3-.28h.01c1.39-1.18 4.32-2.03 8.04-2.38l-.14 1.79c-.08 1.3 3.19 2.56 7.31 2.81 4.11.25 7.51-.6 7.59-1.9l.11-1.56c2.54.66 4.58 1.51 5.81 2.46.11.09.34.27.64.58 1 .99 2.74 3.15 2.9 6.36.21 4.17-2.41 6.87-2.93 7.37 0 0-.02.02-.04.03-1.29 1.05-6.57 4.27-16.51 3.07-5.86-.71-11.99-1.44-14.79-6.08-1.67-2.77-1.44-5.75-1.42-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-29)",
          }}
        />
        <path
          id="path618"
          d="M326.28 303.43s.35-3.77 3.05-6.26c0 0 .03-.03.07-.06.12-.13.22-.21.3-.28h.01c1.39-1.18 4.32-2.03 8.04-2.38l-.14 1.79c-.08 1.3 3.19 2.56 7.31 2.81 4.11.25 7.51-.6 7.59-1.9l.11-1.56c2.54.66 4.58 1.51 5.81 2.46.11.09.34.27.64.58 1 .99 2.74 3.15 2.9 6.36.21 4.17-2.41 6.87-2.93 7.37 0 0-.02.02-.04.03-1.29 1.05-6.57 4.27-16.51 3.07-5.86-.71-11.99-1.44-14.79-6.08-1.67-2.77-1.44-5.75-1.42-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-30)",
          }}
        />
        <g
          id="g626"
          clipPath="url(#clippath-21)"
          style={{
            clipPath: "url(#clippath-21)",
          }}
        >
          <g
            id="g624"
            clipPath="url(#clippath-22)"
            style={{
              clipPath: "url(#clippath-22)",
            }}
          >
            <g
              id="g622"
              clipPath="url(#clippath-23)"
              style={{
                clipPath: "url(#clippath-23)",
              }}
            >
              <image
                xlinkHref="data:image/png;base64,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"
                id="image620"
                width={96}
                height={66}
                transform="matrix(.48 0 0 .48 322.24 272.96)"
              />
            </g>
          </g>
        </g>
        <path
          id="path628"
          d="M328.19 271.38s.35-3.77 3.05-6.26c0 0 .03-.03.07-.06.12-.13.22-.21.3-.28h.01c1.39-1.18 4.32-2.03 8.04-2.38l-.14 1.79c-.08 1.3 3.19 2.56 7.31 2.81 4.11.25 7.51-.6 7.59-1.9l.11-1.56c2.54.66 4.58 1.51 5.81 2.46.11.09.34.27.64.58 1 .99 2.74 3.15 2.9 6.36.21 4.17-2.41 6.87-2.93 7.37 0 0-.02.02-.04.03-1.29 1.05-6.57 4.27-16.51 3.07-5.86-.71-11.99-1.44-14.79-6.08-1.67-2.77-1.44-5.75-1.42-5.94Z"
          style={{
            fill: "url(#linear-gradient-123230841248-31)",
          }}
        />
        <path
          id="path630"
          d="m295.04 107.01 13.29 11.35 116.73-.55-45.25 279.63-109.68.12 18.09 11.39 101.31-.11c14.13-87.11 34.78-214.73 48.84-301.84l.11-.67-143.44.67Z"
          className="cls-5"
        />
        <path
          id="path632"
          d="m247.09 403.23-86.04 21.15-13.67 3.36-30.04 7.38-24.9-292.02 136.59-35.42c-5.06-2.62-10.12-5.24-15.18-7.85l-133.6 34.64 26.85 314.92 156.96-38.58-16.98-7.58Z"
          className="cls-5"
        />
      </g>
    </g>
  </svg>
)
